module.exports = __webpack_public_path__ + "static/media/fire.096011e0.png";